import React from 'react';
import {Trans} from 'react-i18next';
import {connect} from 'react-redux';
import {
    findCollaborators,
} from '../../../../../../../actions/sharingDetailsActions';
import ViewCollaboratorsList from './components/view-collaborators-list';
import './index.css';

class ViewCollaboratorsPopup extends React.Component {

    componentDidMount(){
        if(this.props.selectedContactsGroup.type === "system"){
	        this.props.setFindCollaborators(6, this.props.collaboratorsPageSize);
        } else {
	        this.props.setFindCollaborators(this.props.selectedContactsGroup.id, this.props.collaboratorsPageSize);
        }
    }

    render(){
        return (
            <div className="view-collaborators position-relative">
                <div className="d-flex align-items-center p-3 border-bottom">
                    <div className="pic bg-primary rounded-circle d-flex align-items-center justify-content-center mr-2 text-center">
                        <svg width="20" height="20" viewBox="0 0 96 69.8" className="align-middle">
                            <path
                                fill="#fff"
                                d="M34.9,34.9c9.6,0,17.5-7.8,17.5-17.5C52.4,7.8,44.6,0,34.9,0c-9.6,0-17.5,7.8-17.5,17.5C17.5,27.1,25.3,34.9,34.9,34.9z M34.9,8.7c4.8,0,8.7,3.9,8.7,8.7c0,4.8-3.9,8.7-8.7,8.7c-4.8,0-8.7-3.9-8.7-8.7C26.2,12.7,30.1,8.7,34.9,8.7z M34.9,39.3 C23.3,39.3,0,45.1,0,56.7v13.1h69.8V56.7C69.8,45.1,46.6,39.3,34.9,39.3z M61.1,61.1H8.7v-4.3C9.6,53.6,23.1,48,34.9,48 c11.8,0,25.3,5.6,26.2,8.7V61.1z M74.2,43.6V30.5H61.1v-8.7h13.1V8.7h8.7v13.1H96v8.7H82.9v13.1H74.2z"/>
                        </svg>
                    </div>
                    <h2><Trans i18nKey="viewCollabText" values={{labelName:this.props.selectedContactsGroup.name}}/></h2>
                </div>
                <ViewCollaboratorsList/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
        collaboratorsPageSize: state.sharingDetailsReducer.collaboratorsPageSize,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFindCollaborators : (selectedLabelId, pageSize) => {
            dispatch(findCollaborators(selectedLabelId, pageSize))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewCollaboratorsPopup);
